import { useEffect } from 'react';

import { useLocation } from 'react-router';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useStarterDashboardV2BannerState } from 'src/app/pages/starterDashboardV2/pageContext';

// eslint-disable-next-line @change/sibling-module-imports
import { useBannerDismissalStorage } from '../../../components/PageBody/components/PageBanner/hooks/useBannerDismissalStorage';

const SIX_HOURS = 6 * 60 * 60 * 1000;

type Promotion = NonNullable<StarterDashboardV2PageData['petition']['freePromotions']>[number];
export function useFreePromotionStatus(promotion: Promotion | undefined) {
	const { actions } = useStarterDashboardV2BannerState();
	const { isBannerDismissed, setBannerDismissed } = useBannerDismissalStorage();
	const location = useLocation();
	const { translate } = useI18n();

	const copyKey = translate('corgi.petition.starter_dashboard_v2.free_promotion_banner.start.button');

	useEffect(() => {
		// ALERTS: comment this line
		if (!promotion) return;

		// Check if this banner has been dismissed in this session
		const bannerKey = `free-promotion-${promotion.id}`;
		if (isBannerDismissed(bannerKey)) return;

		// ALERTS: comment this line
		const fulfillmentTime = promotion.fulfilledAt ? new Date(promotion.fulfilledAt).getTime() : 0;
		const currentTime = Date.now();

		// ALERTS: comment this line
		if (promotion.fulfilledAt && currentTime - fulfillmentTime > SIX_HOURS) return;

		actions.addBanner({
			message: translate('corgi.petition.starter_dashboard.free_promotion_banner.start.title'),
			primaryAction: {
				to: `${location.pathname + location.search}#petition-insights-title`,
				text: copyKey,
				type: 'link' as const,
				preventScrollReset: true,
			},
			severity: 'success' as const,
			dismissable: true,
			onClose: () => {
				// Mark this banner as dismissed for the current session
				setBannerDismissed(bannerKey);
			},
		});
	}, []);
}
